<template>
  <div
    class="vertically-centered scan-wrapper"
    :style="{backgroundImage: `url(${bgImage})`}"
  >
    <div class="full-area vertically-centered bg-image qr-page">
      <div class="qr-camera-wrapper">
        <qrcode-stream @decode="onDecode" :key="randomKey" ></qrcode-stream>
      </div>

      <div class="overlay" :class="{'hidden': !decoded}">
        <transition name="fade">
          <div class="instructions qr-content" v-if="!decoded">
            <Icons
              class="icon qr-code-icon slideEntry"
              icon="qr-code"
              size="240"
              :color="'rgba(255,255,255,0.2)'"
            ></Icons>
            
          </div>
        </transition>

        <div class="qr-content">
          <transition name="fade">
            <div class="success-message delay-entry" v-if="decoded">
              <div @click="restart()">
                <Icons
                  class="icon"
                  icon="reload"
                  size="96"
                  :color="'rgba(255,255,255,0.8)'"
                ></Icons>
              </div>
            </div>
          </transition>

          <div
            class="qr-input-field"
            v-if="decoded"
          >
            <div v-if="url" class="column-content">
              <div class="decoded-content" @click="goToURL()">
                <span class="protocol">{{selected | protocol}}</span>{{selected | noProtocol}}
              </div>
              <el-button
                type="danger"
                @click="goToURL()"
                class="submit-button"
                v-if="url"
              >Go!</el-button>
            </div>
            <div v-else class="column-content">
              {{selected}}
              <input type="text" class="decoded-no-url" ref="decodedContent" @click="copyContent()" v-model="selected"/>
              <el-button
                type="danger"
                @click="copyContent()"
                class="submit-button delay-entry"
                v-if="!url"
                :key="copyText"
              >{{copyText}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: 'QRReader',

  transition: 'page',

  props: [ 'bgImage' ],

  components: {
    VueMarkdown,
    QrcodeStream,
    Icons: () => import('Components/base/Icons')
  },

  data () {
    return {
      copyText: 'Copy!',
      randomKey: Math.random(),
      qrInput: null,
      url: null,
      decoded: false,
      selected: null,
    }
  },

  computed: {
    routeName () {
      return this.$route.name
    }
  },

  methods: {
    copyContent () {
      this.copyText = 'Copied!'
      this.$refs.decodedContent.select()
      document.execCommand("copy")
      setTimeout(() => {
        this.$refs.decodedContent.blur()
      }, 2)
    },
    restart () {
      this.copyText = 'Copy!'
      this.qrInput = null
      this.url = null
      this.decoded = false
      this.selected = null
      this.randomKey = Math.random()
    },
    onDecode ($event) {
      this.qrInput = $event
      this.selected = this.qrInput
      this.decoded = true
    },
    isValidURL(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(str);
    },
    goToURL () {
      window.location.href = this.selected
    }
  },

  filters: {
    protocol (href) {
      var a = new URL(href)
      return a.protocol + '//'
    },
    noProtocol (href) {
      var a = new URL(href)
      var b = href.split(`${a.protocol}//`)
      return b[1]
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'selected': function (newVal, oldVal) {
      if (this.isValidURL(newVal)) {
        this.url = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.decoded-no-url {
  position: absolute;
  margin-top: -10000px;
}
.scan-wrapper {
  height: 100vh;
  background-position: 100% 100%;
  background-color: rgba($color-emphasis, 0.2);
  background-repeat: no-repeat;
  background-size: 0;
  @include breakpoint($tablet) {
    background-size: 40%;
    background-position: -15% 105%;
  }
}
.qr-content {
  height: 100vh;
  width: 100%;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 1.5em;
  @include breakpoint($tablet) {
    font-size: 0.8em;
  }
}
.decoded-content {
  display: inline;
  overflow-wrap: break-word;
}
.qr-input-field {
  max-width: 95%;
}
.column-content {
  display: flex;
  flex-direction: column;
  margin: auto;
  line-height: 1;
  margin-top: 0.5em;
}
.full-area {
  overflow: hidden;
  position: relative;
  max-height: 100vh;
  height: 100vh;
  background-color: rgba($color-emphasis, 0.2);

  .overlay {
    z-index: 20;
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgba(#100014, 0.9);
    transition: background 0.2s ease-in-out;

    &.hidden {
      background: transparent;
    }
  }
}
.protocol {
  color: rgba(white, 0.3);
}

.qr-camera-wrapper {
  position: absolute;
  max-height: 100vh;
  z-index: 1;
  .wrapper {
    padding: 0;
  }
}
.submit-button {
  transform: scale(1.3);
  display: inline;
  max-width: 45%;
  margin: auto;
  margin-top: 2em;
  min-width: 100px;
}
.instructions {
  background: rgba(#100014, 0.2);
}

.slideEntry {
  animation: shakeItMore 1.22s ease-in-out infinite forwards;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  animation-delay: 1.2s;
}

@keyframes shakeItMore {
  0% { transform: rotate(0deg) scale(1); opacity: 0.9;}
  20% { transform: rotate(-0deg) scale(1.01); opacity: 1; }
  40% { transform: rotate(-0deg) scale(1); opacity: 0.9; }
  100% { transform: rotate(-0deg) scale(1); opacity: 0.9; }
}


</style>
<style lang="scss">
.qr-input-field {
  .el-textarea {
    font-size: 2em;
    font-family: monospace;
    margin-bottom: 0.5em;
  }
  .el-textarea__inner:focus {
    border-color: rgba($gray-medium, 0.4);
  }
  .el-input__inner {
    border: 1px solid $color-emphasis;
    text-align: center !important;
    font-size: 2em;
    padding: 1em;
    font-family: monospace;
  }
  .el-input__inner:focus {
    border-color: rgba($gray-medium, 0.4);
  }
}

</style>
